var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"close":"","outline":"","color":"accent"},model:{value:(_vm.chip),callback:function ($$v) {_vm.chip=$$v},expression:"chip"}},[(_vm.schedule.text === 'private_parking_products_allDay')?_c('span',[_vm._v(_vm._s(_vm.$t(_vm.schedule.text)))]):_c('span',[_vm._v(_vm._s(_vm.schedule.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0336bd96","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/VChipClosableWrapper.vue
// module id = null
// module chunks = 